<div class="flex h-screen flex-col items-center justify-center">
	<h1 class="error-404 !text-8xl font-extrabold text-white">404</h1>
</div>
